import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { FaHandSpock, FaLocationArrow } from "react-icons/fa";
import SplitType from "split-type";

const Data = () => {
  const titleRef = useRef(null);

  const subtitleRef = useRef(null);
  const descriptionRef = useRef(null);
  const buttonRef = useRef(null);
  useEffect(() => {
    const myText = new SplitType("#my-text");
    console.log(myText);
    gsap.to(".char", {
      y: 0,
      stagger: 0.05,
      delay: 0.2,
      duration: 0.1,
    });
    gsap.fromTo(
      [subtitleRef.current, descriptionRef.current, buttonRef.current],
      { opacity: 0, y: 50 }, // Start from opacity 0 and 50 pixels below their final position
      {
        opacity: 1, // Animate to full opacity
        y: 0, // Animate to final y position
        duration: 1, // Duration of the animation
        stagger: 0.5, // Delay between start of each animation
        ease: "power1.out", // Use an easing function for a smoother animation
        delay: 1,
      }
    );
  }, []);

  return (
    <div className="home__data">
      <h1 className="home__title" ref={titleRef}>
        <span id="my-text">
          Mizero Maxime <FaHandSpock className="hand" />
        </span>
      </h1>
      <h3 className="home__subtitle" ref={subtitleRef}>
        Full-Stack & AI/ML Developer
      </h3>
      <p className="home__description" ref={descriptionRef}>
        I’m a creative, dedicated developer with over six years of experience
        building user-focused applications and innovative solutions. I turn
        ideas into high-quality products that streamline processes and delight
        users. Always learning and adapting, I’ve designed intuitive interfaces
        and worked on data-driven projects that drive better decisions.
      </p>
      {/* I am a designer who is passionate about his art and uses technology to create functional art to help you realize your dreams. */}
      <a
        href="#contact"
        className="button button--flex opacity"
        ref={buttonRef}
      >
        Say Hello <FaLocationArrow className="button-icon" />
      </a>
    </div>
  );
};
export default Data;
